import { render, staticRenderFns } from "./DetailsSummaryPage.vue?vue&type=template&id=5b0655a7&lang=pug"
import script from "./DetailsSummaryPage.vue?vue&type=script&lang=ts"
export * from "./DetailsSummaryPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports